import React from 'react';
import './SearchBar.css';
//import {ReactComponent as SearchSvgIcon} from './../../../assets/svg/akar-icons_search.svg';

import SearchSvgIcon from './../../../assets/svg/akar-icons_search.svg';

type DynamicSearchBarProps = {
  onChange: (value: string) => void;
  placeHolder: string;
  searchName?: string;
  disabled?: boolean;
  className?: string;
  iconNeeded?: boolean;
  required?:boolean;
};

const SearchIcon = {
  img: <SearchSvgIcon className="search_bar_icon" />
};


const DynamicSearchBar = ({
  onChange,
  placeHolder,
  searchName,
  disabled,
  className,
  iconNeeded,
  required,
}: DynamicSearchBarProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };
  return (
    <div className={`search-bar-container ${className}`}>
      {searchName && (
        <label  className={`search-name-fromparent ${required && 'yes'} ${disabled}`}>{searchName}</label>
      )}
      <div className="search_bar_form-field">
        {/* <img className="search_bar_icon" src={SearchSvgIcon}></img> */}
        {iconNeeded ? SearchIcon.img : null}
        <input
          className="search_bar_input_field"
          placeholder={placeHolder}
          onChange={handleChange}
          disabled={disabled}
        />
      </div>
    </div>
  );
};

export default DynamicSearchBar;
